import { GridApiPro } from '@mui/x-data-grid-pro'
import { AddOutlined, Refresh, TuneOutlined } from '@mui/icons-material'

import { Stack, SearchTextField, Button, IconButton } from '@collaborate-health/uikit'
import { ScopeSelector } from '@tabeeb/modules/certificates/components'
import { useCurrentCorporation } from '@tabeeb/modules/admin/corporations/hooks'

import { Scope } from '../../enums'

export interface UserQualificationsGridToolbarProps {
  filtersActive?: boolean
  showScopeSelector?: boolean
  showAddButton?: boolean
  onOpenAddEditDialog: () => void
  onReload: () => void
  loading: boolean
  gridApiRef: React.MutableRefObject<GridApiPro>
  searchText: string
  onSearchChange: (search: string) => void
  scope: Scope
  onScopeChange: (scope: Scope) => void
}

const UserQualificationsGridToolbar: React.FC<UserQualificationsGridToolbarProps> = ({
  filtersActive = false,
  showScopeSelector = false,
  scope,
  onScopeChange,
  showAddButton = true,
  onOpenAddEditDialog,
  onReload,
  loading,
  gridApiRef,
  searchText,
  onSearchChange,
}) => {
  const { canManageCorporationQualifications } = useCurrentCorporation({ enabled: showScopeSelector })

  return (
    <Stack direction='row' spacing={2} mb={2} alignItems='center' justifyContent='space-between'>
      <SearchTextField
        size='small'
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder='Search qualifications...'
        InputProps={{
          endAdornment: (
            <IconButton
              size='small'
              color={filtersActive ? 'primary' : undefined}
              onClick={() => gridApiRef.current?.showFilterPanel()}
            >
              <TuneOutlined fontSize='small' />
            </IconButton>
          ),
        }}
      />
      <Stack direction='row' spacing={1}>
        <Button color='primary' size='small' startIcon={<Refresh />} disabled={loading} onClick={onReload}>
          Refresh
        </Button>
        {showScopeSelector && canManageCorporationQualifications && (
          <ScopeSelector value={scope} onChange={onScopeChange} />
        )}
        {showAddButton && (
          <Button
            color='primary'
            variant='contained'
            size='small'
            startIcon={<AddOutlined />}
            onClick={onOpenAddEditDialog}
          >
            Assign user qualification
          </Button>
        )}
      </Stack>
    </Stack>
  )
}

export default UserQualificationsGridToolbar

